module.exports = __webpack_public_path__ + "img/logo.a6f444fc.png";